<script>
import axios from 'axios'

import is from '../web/plugins/helper/is'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

let currentElement = null

export default {
  extends: IncludeHelperComponent,
  name: 'vue-weirdotab',
  props: {
    data: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    includepercentage: {
      type: Number,
      default: 0,
    },
    inspeccion: {
      type: Boolean,
      default: true,
    },
    separateHouse: {
      type: Number,
      default: 0,
    },
    attrIcontent: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      results: [],
      selected: false,
    }
  },
  methods: {
    __getInputType() {
      return this.data.type !== undefined && this.data.type !== null ? this.data.type : 'text'
    },
    __getParentItems(element) {
      return element.parents()
    },
    __addElementAnimation(element, animate) {
      element.animate(animate, 200)
    },
    __getAttrsInput() {
      switch (this.data.tag) {
        case 'input':
          const type = this.__getInputType()
          const attrs = {
            class: 'input-weirdo-style',
          }

          switch (type) {
            case 'checkbox':
              attrs['name'] = this.data.name
              attrs['data-index'] = this.index
              attrs['checked'] = this.data.checked
              attrs['type'] = type
              attrs['disabled'] = !this.inspeccion
              break
            case 'file':
              const { id, visible, editable } = this.data
              let inspeccion = this.inspeccion
              if (id !== 0 && visible === true && editable === true && !this.checkVariable(this.__setValueOfInput())) {
                inspeccion = true
              }
              attrs['type'] = type
              attrs['disabled'] = !inspeccion
              attrs['accept'] = this.data.accept
              attrs['data-index'] = this.index
              break
            default:
              attrs['placeholder'] = this.placeholder
              attrs['disabled'] = !this.inspeccion
              attrs['type'] = type
              break
          }

          return attrs
        case 'select':
          let withDisabled = false
          const disabled = this.data !== undefined && this.data.disabled !== undefined
          if (disabled) {
            withDisabled = this.data.disabled
          }
          if (this.inspeccion === false) {
            withDisabled = true
          }
          const setting = {
            class: 'input-weirdo-style',
            disabled: withDisabled,
          }

          return setting
        case 'img':
          return {
            src: this.value,
          }
      }
    },
    __getAttrsContent() {
      return {
        class: 'list-group',
        id: 'filter-list-repuesto',
        style: 'position: absolute;width: 164px;height: auto;max-height: 160px;z-index: 10000;padding: 0;margin: 0;overflow-y: scroll;',
      }
    },
    __setValueOfInput() {
      if (typeof this.data.value === 'object') {
        return this.data.value[this.index]
      }

      let newValue = this.data.value
      if (this.checkVariable(this.data) && this.checkVariable(this.data.type) && this.data.type === 'number') {
        newValue = this.getValueNumber(newValue)
      }
      if (this.checkVariable(this.data) && !this.checkVariable(this.data.type)) {
        return this.getValueNumber(newValue)
      }

      return newValue
    },
    __getInputName() {
      if (typeof this.data.name === 'object') {
        return this.data.name[this.index]
      }

      return this.data.name
    },
    __determineObject(value) {
      if (typeof this.data.name === 'object') {
        if (this.isArray(this.data.value)) {
          this.$set(this.data.value, this.index, value)
        } else {
          this.$set(this.data, 'value', value)
        }
      } else {
        let newValue = value
        if (this.checkVariable(this.data) && this.checkVariable(this.data.type) && this.data.type === 'number') {
          newValue = this.getValueNumber(value)
        }
        if (this.checkVariable(this.data) && !this.checkVariable(this.data.type)) {
          newValue = this.getValueNumber(value)
        }
        this.$set(this.data, 'value', newValue)
      }
    },
    __search(value) {
      const self = this
      const params = {
        id: self.data.id,
        name: self.__getInputName(),
        value: value,
      }

      if (self.data.idparent !== undefined) {
        params.parent_id = self.data.idparent
      }

      // Event produced when leaving the input
      axios
        .post(self.data.url, params)
        .then(response => {
          if (self.data.search) {
            const result = response.data
            self.results = result
          }
        })
        .catch(function(error) {
          self.defaultSettingsToastSwal()
          self.swalTitle = self.$t('error_alert_title')
          self.swalText = error
          self.positionedDialogToast()
        })

      return true
    },
    __validate(targetValue) {
      if (
        this.data.min !== undefined &&
        this.data.max !== undefined &&
        (targetValue.length < this.data.min &&
          targetValue.length > this.data.max)
      ) {
        return false
      }

      if (
        (this.data.search || this.data.tag === 'select') &&
        (this.data.url !== undefined) &&
        (this.data.runserver !== undefined && this.data.runserver === true)
      ) {
        return this.__search(targetValue)
      } else {
        this.__determineObject(targetValue)

        return true
      }
    },
    createOptions(createElement, options) {
      const tempOptions = []
      const rOption = this.findWith(options, { 'value': '' })
      if (rOption === -1) {
        this.insertArray(options, 0, { 'text': this.$t('to_select'), 'value': '' })
      }
      Object.keys(options).forEach(index => {
        const text = options[index].text || options[index].value
        const value = options[index].id || options[index].value
        const isUndefined = this.isUndefined(options[index].default)
        if (isUndefined === false && this.data.value === '') {
          this.__determineObject(options[index].default)
        }
        let attrs = {
          value,
          selected: (value === this.data.value),
        }
        const disabled = options[index].disabled !== undefined ? options[index].disabled : false
        if (this.isBooleand(disabled)) {
          attrs = { ...attrs, disabled }
        }
        const selected = options[index].selected !== undefined ? options[index].selected : false
        if (this.isBooleand(selected) || this.isString(selected)) {
          attrs = { ...attrs, selected }
        }
        if (isUndefined === true && value === '') {
          attrs = { ...attrs, disabled: true }
        }
        const option = createElement('option', { attrs }, text)
        tempOptions.push(option)
      })

      return tempOptions
    },
    animation(patherElement, currentElementActive) {
      if (currentElementActive) {
        this.__addElementAnimation(currentElementActive, { opacity: 1, height: '70px' })
      }
      if (patherElement) {
        this.__addElementAnimation(patherElement, { opacity: 1, width: '50vh' })
      }
    },
    addAnimationTh(patherElement, currentElementActive) {
      currentElement = patherElement
      this.animation(patherElement, currentElementActive)
    },
    addAnimationTd(patherElement, currentElementActive) {
      this.animation(patherElement, currentElementActive)
    },
  },
  render(createElement) {
    let tempOptions = []
    const self = this
    let ul = null

    if (['input', 'select', 'img'].indexOf(self.data.tag, 0) === -1 || self.data.tag === undefined) {
      return createElement(self.data.tag, self.data.value)
    }

    if (self.data.tag === 'select' && Object.keys(self.data.option).length > 0) {
      const options = self.data.option
      tempOptions = self.createOptions(createElement, options)
    }

    if (self.data.tag === 'img' && self.isArray(self.data.value)) {
      let img = []
      self.data.value.forEach(src => {
        img.push(createElement(
          'img',
          {
            domProps: { value: '' },
            attrs: { src, class: 'rounded m-1 img-thumbnail' },
            on: {
              click(event) {
                const element = event.target
                const src = element.src
                self.$emit('clickImg', { ...self.data, value_apply: src })
              },
            },
          },
        ))
      })

      return createElement(
        'div', {
          attrs: this.attrIcontent,
        }, img)
    }

    const newValue = self.__setValueOfInput()
    const input = createElement(
      self.data.tag,
      {
        domProps: {
          value: newValue || '',
        },
        attrs: self.__getAttrsInput(),
        on: {
          input(event) {
            const element = event.target
            const value = element.value
            const isValid = self.__validate(value)
            if (isValid === false) {
              is.addClass(element, 'error')
            } else {
              is.removeClass(element, 'error')
            }
            if (self.data && self.data.useReferenceEvent) {
              self.$emit('changeData', self.data)
            }
          },
          focus(event) {
            const element = $(event.target)
            const type = self.__getInputType()
            if (type === 'text') {
              const parents = self.__getParentItems(element)
              const thElement = parents.closest('th')
              if (thElement && thElement.length > 0) {
                const localCurrentId = thElement.attr('id')
                if (currentElement !== null && localCurrentId !== currentElement.attr('id')) {
                  currentElement.removeAttr('style')
                  currentElement.closest('thead').find('input').removeAttr('style')
                }
                self.addAnimationTh(thElement, element)
              }
            }
          },
        },
      },
      tempOptions,
    )

    if (self.results.length > 0 && self.data.search) {
      const attrsContent = self.__getAttrsContent()
      ul = createElement(
        'ul',
        {
          attrs: attrsContent,
        },
        self.results.map(function(v) {
          return createElement(
            'li',
            {
              attrs: {
                class: 'list-group-item',
              },
            },
            [createElement('a', v.name)],
          )
        }),
      )
    }

    return createElement('div', [input, ul])
  },
}
</script>
